import { Tag } from 'antd';

export interface FieldWarningProps {
  message: string;
  className?: string;
}

const FieldWarning = ({ message, className }: FieldWarningProps) => {
  return (
    <Tag
      color="orange"
      className={`max-w-96 w-fit text-wrap block ${className || ''}`}
    >
      {message}
    </Tag>
  );
};

export default FieldWarning;
